module.exports = __webpack_public_path__ + "static/img/shuiji1.0434f3d4.webp";